import {BarycentricTriangleInput, type BarycentricCoordinates} from '@hconnect/uikit/src/lib2'

import type {OptimizerPriorities} from '../../../shared/interfaces/api'

import {
  mapBarycentricCoordinatesToOptimizerPriorities,
  mapOptimizerPrioritiesToBarycentricCoordinates,
  useOptimizerPrioritiesStyles
} from './optimizerPriorities.helpers'

interface OptimizerPrioritiesTriangleInputProps {
  initialValue: OptimizerPriorities
  value: OptimizerPriorities
  setValue: (value: OptimizerPriorities) => void
}

export const OptimizerPrioritiesTriangleInput: React.FC<OptimizerPrioritiesTriangleInputProps> = ({
  initialValue,
  value,
  setValue
}) => {
  const styles = useOptimizerPrioritiesStyles()

  return (
    <BarycentricTriangleInput
      initialValue={mapOptimizerPrioritiesToBarycentricCoordinates(initialValue)}
      value={mapOptimizerPrioritiesToBarycentricCoordinates(value)}
      setValue={(coordinates: BarycentricCoordinates) => {
        setValue(mapBarycentricCoordinatesToOptimizerPriorities(coordinates))
      }}
      verticeStyles={styles}
    />
  )
}
